import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '../../../../components/mui/Styles/index'
import { Box, Button, Card, CardContent, Typography } from '../../../../components/mui/Core/index'
import FormHeading from '../../../../components/userauthentication/FormHeading'
import Constants from '../../../../constants/en.json'
import { routePaths } from '../../../../constants/routes'

function SignUpCompleted() {
  const theme = useTheme()
  const navigate = useNavigate()

  const handleReturnToLogin = () => {
    navigate(routePaths.LOGIN)
  }

  const cardContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const messageContainerStyle = { textAlign: 'center', marginTop: '12px' }
  const buttonContainerStyle = { marginTop: '40px', height: '40px' }
  const buttonStyle = { padding: '9px 34px 10px', borderRadius: '20px', backgroundColor: '#2db47d' }

  return (
    <Box sx={theme.soloContainer}>
      <Card className='soloCard'>
        <CardContent sx={cardContentStyle}>
          <FormHeading formHeader={Constants.signUpComplete.SIGNUP_COMPLETE} />
          <Box sx={messageContainerStyle}>
            <Typography variant='cardMessage'>
              {Constants.signUpComplete.SIGNUP_COMPLETE_MESSAGE}
            </Typography>
          </Box>
          <Box sx={buttonContainerStyle}>
            <Button variant='contained' sx={buttonStyle} onClick={handleReturnToLogin}>
              {Constants.signUpComplete.RETURN_TO_LOGIN}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default SignUpCompleted
